export default __webpack_public_path__ + "static/media/IMG-20210825-WA0019.77398d2a.jpg";